// STYLED COMPONENTS
import styled from "styled-components";

// MATERIAL UI
import { Typography } from "@mui/material";

// ICONS
import { ErrorOutlineOutlined } from "@mui/icons-material";

const ErrorContainer = styled(Typography)(({ theme }) => ({
  color: "#cc0000",
  display: "flex",
  justifyContent: "left",
  alignItems: "center",
  padding: "8px 0",
}));

const ErrorText = styled(Typography)<{ fontSize?: string }>(({ theme, fontSize }) => ({
  marginLeft: "5px",
  fontSize: fontSize,
}));

interface IErrorProps {
  children: React.ReactNode;
  fontSize?: string;
}

const errorIconStyles = { width: "16px" };

/**
 * The StyledError component.
 *
 * @param {React.ReactNode} children - The children to render.
 * @param {string} fontSize - The font size to render.
 * @returns {JSX.Element} The JSX code to render the StyledError component.
 */
export const StyledError = ({ children, fontSize = "14px" }: IErrorProps): JSX.Element => {
  return (
    <ErrorContainer id="withdraw-modal-error">
      <ErrorOutlineOutlined style={errorIconStyles} />
      <ErrorText fontSize={fontSize}>{children}</ErrorText>
    </ErrorContainer>
  );
};
